import * as React from 'react'

const SvgAudioIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 42 38" fill="none" {...props}>
    <path
      d="M41.63 23.003v-.177c0-.84-.133-3.892-.222-4.821C40.257 7.565 31.756 0 21.218 0 15.905 0 10.902 1.99 7.094 5.618 3.33 9.246 1.072 14.245.762 19.598a52.697 52.697 0 00-.088 2.919V33.842c0 2.3 1.86 4.158 4.162 4.158h3.32a4.155 4.155 0 004.162-4.158V23.18c0-2.3-1.86-4.158-4.161-4.158H5.1c.842-8.493 7.66-14.82 16.161-14.82 8.324 0 15.054 6.017 15.984 14.29 0 .132.044.309.044.53h-3.055a4.155 4.155 0 00-4.162 4.158v10.662c0 2.3 1.86 4.158 4.162 4.158h3.277a4.155 4.155 0 004.162-4.158V23.18c-.044-.044-.044-.132-.044-.177zm-35.82.266h1.328c.487 0 .886.398.886.885v8.714a.888.888 0 01-.886.885H5.81a.888.888 0 01-.886-.885v-8.714c0-.487.399-.885.886-.885zm31.613 9.6a.888.888 0 01-.885.884H35.21a.888.888 0 01-.886-.885v-8.714c0-.487.398-.885.886-.885h1.328c.487 0 .885.398.885.885v8.714z"
      fill="url(#AudioIcon_svg__paint0_linear)"
    />
    <defs>
      <linearGradient
        id="AudioIcon_svg__paint0_linear"
        x1={5}
        y1={0}
        x2={42}
        y2={38}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.714} stopColor="#5937BC" />
        <stop offset={0.984} stopColor="#3F38A6" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgAudioIcon
